import { render } from "./InlineCreateChildInstance.vue?vue&type=template&id=8070a140&scoped=true"
import script from "./InlineCreateChildInstance.vue?vue&type=script&lang=js"
export * from "./InlineCreateChildInstance.vue?vue&type=script&lang=js"

import "./InlineCreateChildInstance.vue?vue&type=style&index=0&id=8070a140&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8070a140"]])

export default __exports__